export default __webpack_public_path__ + "static/ORR-01-01-ccbb955f272548ed88ec84a865527c84.webp";